var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "side-file",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "side-file__title"
  }, [_c('span', [_vm._v(" 첨부파일 ")])]), _c('v-card-text', {
    staticClass: "px-6"
  }, [_c('v-row', {
    staticClass: "ma-n1"
  }, [_vm._l(_vm.fields, function (field, index) {
    return [_c('v-col', {
      key: field.tempId,
      staticClass: "pa-1",
      attrs: {
        "cols": "12"
      }
    }, [_c('side-file-item', _vm._g({
      model: {
        value: _vm.fields[index],
        callback: function ($$v) {
          _vm.$set(_vm.fields, index, $$v);
        },
        expression: "fields[index]"
      }
    }, {
      input: _vm.emit,
      pull: _vm.pull
    }))], 1)];
  }), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "side-file__item",
    attrs: {
      "flat": "",
      "color": "secondary lighten-5"
    },
    on: {
      "click": _vm.push
    }
  }, [_c('v-card-title', {
    staticClass: "side-file__item__title"
  }, [_c('span', [_vm._v(" 파일추가 ")]), _c('v-spacer'), _c('v-icon', {
    attrs: {
      "size": "20",
      "color": "black"
    }
  }, [_vm._v(" mdi-plus ")])], 1)], 1)], 1)], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }